export const environment = {
  production: false,
  apiUrl: 'https://ms-mb-gateway-ws-nest.apps.dev-bl.kota.mx/api',
  keycloakUrl: 'https://sc-mb-sso.qa.swisscrown.com.mx',
};
